module.exports = __webpack_public_path__ + "img/top-sub-4.ea684dd.png";